import ITShowcaseEvent from "./ITShowcaseEvent";

export default class EventOrganizer {
    name = '';
    token = '';

    ctx;

    constructor(ctx, name, token) {
        this.ctx = ctx;
        this.name = name;
        this.token = token;
    }

    async login(email, password) {
        const response = await this.ctx.httpRequest('/organizer/login', 'post', {
            data: {
                email,
                password,
            },
            disableAuth: true,
        });

        if (response.result === 'success') {
            const data = response.data;
            this.name = data.name;
            this.token = data.token;
        }

        return response;
    }

    async logout() {
        const response = await this.ctx.httpRequest('/organizer/logout', 'delete');
        return response;
    }

    async retrieveITShowcaseEvents() {

    }

    async retrieveITShowcaseEvent(id) {
        const response = await this.ctx.httpRequest(`/organizer/event/${id}`, 'get');
        if (response.result !== 'success') {
            return false;
        }

        const data = this.ctx.replaceUrl(response.data);
        const itShowcaseEvent = new ITShowcaseEvent(data.title, data.description, data.bannerUrl, data.createdAt, data.status, data._id);
        itShowcaseEvent.setEnableVoting(data.enableVoting);
        itShowcaseEvent.setEnableLocalStation(data.enableLocalStation);
        itShowcaseEvent.setLocalVotingStation(data.localVotingStation || {});
        itShowcaseEvent.setARImageTargets(data.arImageTargets || []);

        return itShowcaseEvent;
    }

    async saveITShowcaseEvent(itShowcaseEvent, mediaSources, arImageTargets) {
        let data = {
            title: itShowcaseEvent.title,
            status: itShowcaseEvent.status,
            description: itShowcaseEvent.description,
            bannerUrl: itShowcaseEvent.bannerUrl && itShowcaseEvent.bannerUrl.length > 0 ? itShowcaseEvent.bannerUrl : undefined,
            enableVoting: itShowcaseEvent.enableVoting,
            enableLocalStation: itShowcaseEvent.enableLocalStation,
            localVotingStation: itShowcaseEvent.localVotingStation || {},

            arImageTargets,
        };

        const pathPrefix = '__host__';
        const uploadImage = async (source, target, targetKey) => {
            const base64 = await this.ctx.blobToBase64(source.url);
            const path = await this.ctx.uploadImage(base64, source.type, source.extension);
            if (!target) {
                return path;
            }

            target[targetKey] = pathPrefix + path;
        };

        const isLocalUrl = (url) => {
            if (!url) {
                return false;
            }
            
            return url.search('blob:') !== -1;
        };

        for (const source of mediaSources.description) {
            if (data.description.search(source.url) === -1) {
                continue;
            }

            const path = await uploadImage(source);
            if (path) {
                const regex = new RegExp(source.url, 'g');
                data.description = data.description.replace(regex, pathPrefix + path);
            }
        }

        if (mediaSources.banner.url) {
            await uploadImage(mediaSources.banner, data, 'bannerUrl');
        }

        for (const arImageTarget of data.arImageTargets) {
            for (const arTarget of arImageTarget.arTargets) {
                if (!isLocalUrl(arTarget.targetUrl)) {
                    continue;
                }

                await uploadImage(mediaSources.arImageTargets[arTarget.targetUrl], arTarget, 'targetUrl');
            }

            for (const arElement of arImageTarget.arElements) {
                if (!(['photo'].includes(arElement.type) && isLocalUrl(arElement.value))) {
                    continue;
                }

                await uploadImage(mediaSources.arImageTargets[arElement.value], arElement, 'value');
            }

            const arContent = arImageTarget.arContent || {};
            arContent.config = JSON.stringify(arContent.config || {});
        }

        for (const [index, sources] of Object.entries(mediaSources.arContent)) {
            const arImageTarget = data.arImageTargets[index];
            const arContent = arImageTarget.arContent;
            if (arContent.type !== 'customContent') {
                continue;
            }
            
            for (const source of sources) {
                if (arContent.value.search(source.url) === -1) {
                    continue;
                }
    
                const path = await uploadImage(source);
                if (path) {
                    const regex = new RegExp(source.url, 'g');
                    arContent.value = arContent.value.replace(regex, pathPrefix + path);
                }
            }
        }

        let requestPath, method;
        if (itShowcaseEvent.id) {
            requestPath = `/organizer/event/${itShowcaseEvent.id}`;
            method = 'put';
        } else {
            requestPath = '/organizer/event';
            method = 'post';
        }

        data = JSON.parse(JSON.stringify(data).replace(new RegExp(process.env.VUE_APP_API_URL, 'g'), '__host__'));

        const response = await this.ctx.httpRequest(requestPath, method, {
            data,
        });

        return response;
    }

    async deleteITShowcaseEvent(id) {
        const response = await this.ctx.httpRequest(`/organizer/event/${id}`, 'delete');
        
        return response;
    }

    async clearRecord(arImageTargetId) {
        const response = await this.ctx.httpRequest(`/organizer/event/custom-record/${arImageTargetId}`, 'delete');
        return response;
    }
}